<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-btn slot="activator" icon>
        <v-icon >edit</v-icon>
      </v-btn>
      <v-card>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Editar Projeto</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
                <v-flex xs12>
              <v-text-field
                id="codigo"
                name="codigo"
                label="Código"
                v-model="projeto.codigo"
                required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="curso"
                name="curso"
                label="Curso"
                v-model="projeto.curso"
                required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="faculdade"
                name="faculdade"
                label="Faculdade"
                v-model="projeto.faculdade"
                required></v-text-field>
            </v-flex>
              

   
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="dialog = false">Fechar</v-btn>
          <v-btn color="primary" flat @click.native="editarProjeto">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "ProjetoEditar",
  props: {
    projeto: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    editarProjeto() {
      let updates = {};
      updates[
        "/projetos/" + this.projeto[".key"] + "/codigo"
      ] = this.projeto.codigo;
      updates[
        "/projetos/" + this.projeto[".key"] + "/curso"
      ] = this.projeto.curso;
      updates[
        "/projetos/" + this.projeto[".key"] + "/faculdade"
      ] = this.projeto.faculdade;
      this.$db.ref().update(updates);
      this.dialog = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProjetoEditar.vue